<template>
  <transfer-page v-if="enabled"/>
  <legacy-main v-else/>
</template>

<script>
import { mapState } from 'vuex';
import TransferPage from './Transfer.vue';
import LegacyMain from './legacy/Main.vue';

export default {
  components: {
    TransferPage,
    LegacyMain,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    enabled() {
      const settings = this.user && this.user.branch && this.user.branch.settings
        ? this.user.branch.settings.insuranceBilling
        : null;
      return !!(settings && settings.enabled);
    },
  },
};
</script>
